export const PASSWORD_REQUIREMENTS_LIST_NUMBER = 3;
